import React from "react";
import { RiSlashCommands } from "react-icons/ri";

function Testimonials({ pic, name, dic }) {
  return (
    <>
      <div className='border max-w-80 text-center'>
        <div className='relative inline-block transform -translate-y-14'>
          <img
            src={pic}
            alt='thumb'
            className='rounded-full h-28 w-28 m-auto'
          />
          <div className='p-1.5 bg-primary rounded-full inline-block absolute bottom-0 right-0'>
            <RiSlashCommands size={25} fill='white' />
          </div>
        </div>
        <div className='px-5 pb-10'>
          <p className='text-gray-500 text-[15px] leading-7'>
            Far far away, behind the word mountains, far from the countries
            Vokalia and Consonantia, there live the blind texts. Separated they
            live in Bookmarksgrove right at the coast of the Semantics, a large
            language ocean.
          </p>
          <div>
            <h1 className='text-primary mt-5'>{name}</h1>
            <p className='text-black/40 mt-1.5'>{dic}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Testimonials;
